import Vue from "vue";
import vuetify from "@/plugins/vuetify.js";
import "material-design-icons-iconfont/dist/material-design-icons.css"

import router from "@/router";
import store from "@/store";
import { LOGOUT } from "@/store/mutation-types";
import axios from "axios";
import VuetifyConfirm from "vuetify-confirm";
import VueMoment from "vue-moment";
import moment from "moment-timezone";
import "moment/locale/es";
import VueApexCharts from "vue-apexcharts"
import VueWordCloud from "vuewordcloud";
import * as GmapVue from "gmap-vue";
import GmapCluster from "gmap-vue/dist/components/cluster"; // replace dist with src if you have Babel issues
import { Network } from "vue-vis-network";

import App from "@/App.vue";

console.log("VUE_APP_COPRA_SERVER_URL", process.env.VUE_APP_COPRA_SERVER_URL);

Vue.prototype.$http = axios;
axios.defaults.baseURL = process.env.VUE_APP_COPRA_SERVER_URL;
axios.defaults.headers.common['Authorization'] = store.getters.getAuth;
axios.interceptors.response.use(undefined, function (error) {
  if (!!error && !!error.response && (error.response.status === 401 || error.response.status === 422)) {
      store.commit(LOGOUT);
      router.push({ path: "/login" });
  }
  throw error;
});

Vue.use(VuetifyConfirm, { vuetify })
Vue.use(VueMoment, { moment, });
Vue.component("apexchart", VueApexCharts)
Vue.component("VueWordCloud", VueWordCloud);
Vue.component("network", Network);
Vue.use(GmapVue, {
  load: {
    key: "AIzaSyAQPHa2Z5WQIJG7PHmYznFpQvuQtuBgfFo",
    libraries: ["places", "visualization"],
    loading: "async"
  },
  installComponents: true
});
Vue.component("GmapCluster", GmapCluster);
Vue.config.productionTip = false;

Vue.mixin({
  created() {
    //console.log("[created] " + this.$options.name)
  },
});

Vue.prototype.$eventBus = new Vue();

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount("#app");
